var map = {
	"./aspasstykki.JPG": 7770,
	"./aspasstykki_1.jpg": 8131,
	"./fetaloka.JPG": 7970,
	"./klubbsamloka.JPG": 1175,
	"./klubbsamloka_1.jpg": 1180,
	"./langlokur_1.jpg": 5409,
	"./luxus_lokur.jpg": 4975,
	"./nautaloka_1.jpg": 3624,
	"./pepp_loka.jpg": 2853,
	"./pulledpork.JPG": 9059,
	"./pítsaloka.JPG": 9443,
	"./samloka_alioli_1.jpg": 8831,
	"./smurtheilhveitihorn.jpeg": 6898,
	"./smurðrunstykki.JPG": 4364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9230;